import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  PasswordInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput,
  minLength,
  email
} from "react-admin";

import { FormToolbar } from "../../common/FormToolbar";

export const UsersCreate = (props) => {
  
  return (
    <Create title="Create User" {...props}>
      <SimpleForm className="main-form" toolbar={<FormToolbar {...props} showDelete={false} />}>
        
        {/* Username - Primary Login Identifier */}
        <TextInput 
          source="username" 
          label="Username / Email"
          validate={[required(), email()]} 
          className="one_two_input"
          helperText="Email address used for login"
          fullWidth
        />
        
        {/* Display Name - User's Full Name */}
        <TextInput 
          source="display_name" 
          label="Display Name"
          validate={[required()]}
          className="two_two_input" 
          helperText="Full name shown in the application"
          fullWidth
        />

        {/* Password - Minimum 8 Characters */}
        <PasswordInput 
          source="password" 
          label="Password"
          validate={[required(), minLength(8)]}
          className="one_two_input" 
          helperText="Minimum 8 characters required"
          fullWidth
        />

        {/* Role Selection */}
        <ReferenceInput 
          label="Role" 
          source="role_id" 
          reference="role" 
          className="two_two_input"
        >
          <SelectInput 
            optionText="role" 
            validate={[required()]} 
            fullWidth
          />
        </ReferenceInput>

        {/* Login Permission */}
        <BooleanInput 
          source="allow_login" 
          label="Allow Login" 
          defaultValue={true}
          className="one_two_input"
          helperText="Enable or disable user login access"
        />

      </SimpleForm>
    </Create>
  );
};
